import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
  Pack,
  PackConfig,
  PackProducto,
  PackIn,
  ActualizarProyectoPackIn,
  GuardarPackIn,
  ContratarProyectoIn,
  NuevoPackResponse,
  CampoProductoVC,
  DescuentosVC,
  DescuentosVcIn,
  PackProyecto,
  TarificacionRapidaIn
} from '../../model/pack.model';
import { Recibo } from '../../model/poliza.model';
import { PolizaSalud } from '../../model/salud.model';

@Injectable({
  providedIn: 'root'
})
export class PackService extends BaseApiService {

  consultarConfigsPacks(input: PackProducto): Observable<PackConfig> {
    return this.invocarSeguros<PackConfig>('POST', 'packs/configs', input);
  }

  crearPack(input: PackIn): Observable<NuevoPackResponse> {
    return this.invocarSeguros<NuevoPackResponse>('POST', 'packs', input);
  }

  anadirProyecto(idPack: number, input: PackProyecto): Observable<PackProyecto> {
    return this.invocarSeguros<PackProyecto>('POST', `packs/${idPack}/proyectos`, input);
  }

  borrarProyecto(idProyecto: number): Observable<void> {
    return this.invocarSeguros<void>('DELETE', `packs/${idProyecto}/proyectos`);
  }

  actualizarProyecto(idPack: number, input: ActualizarProyectoPackIn): Observable<void> {
    return this.invocarSeguros<void>('PUT', `packs/${idPack}/proyectos`, input);
  }

  actualizarSeleccionProyecto(idPack: number, seleccion: boolean): Observable<void> {
    return this.invocarSeguros<void>('PUT', `packs/${idPack}/proyectos/${seleccion}`);
  }

  guardarPack(idPack: number, input: GuardarPackIn): Observable<void> {
    return this.invocarSeguros<void>('PUT', `packs/${idPack}`, input);
  }

  eliminarPack(idPack: number): Observable<void> {
    return this.invocarSeguros<void>('DELETE', `packs/${idPack}`);
  }

  contratarProyecto(idPack: number, input: ContratarProyectoIn): Observable<void> {
    return this.invocarSeguros<void>('PUT', `packs/${idPack}/proyectos/contratar`, input);
  }

  consultarPack(idPack: number): Observable<Pack> {
    return this.invocarSeguros<Pack>('GET', `packs/${idPack}`);
  }

  consultarPackPorProyecto(idProyecto: number): Observable<Pack> {
    return this.invocarSeguros<Pack>('GET', `packs/pack-proyecto/${idProyecto}`);
  }

  consultarCamposProductoVC(codCia: string, codRamo: string, codModa: string, codSubmoda: string, idProyectoPrincipal: number): Observable<CampoProductoVC[]> {
    return this.invocarSeguros<CampoProductoVC[]>('GET', `packs/campos/${codCia}/${codRamo}/${codModa}/${codSubmoda}/${idProyectoPrincipal}`);
  }

  consultarDescuentosVC(input: DescuentosVcIn): Observable<DescuentosVC> {
    return this.invocarSeguros<DescuentosVC>('POST', 'packs/descuentos', input);
  }

  retarificarPropuestaColectiva(codPropuesta : string, codColectiva: string) : Observable<PolizaSalud>{
    return this.invocarSeguros<PolizaSalud>('GET', `salud/propuesta/tarificacion-rapida/${codPropuesta}/${codColectiva}`);
  }

  retarificarPropuestaDental(codPropuesta : string) : Observable<PolizaSalud>{
    return this.invocarSeguros<PolizaSalud>('GET', `salud/propuesta/tarificacion-dental/${codPropuesta}`);
  }

  consultarColectiva(codProductoVC: string): Observable<string> {
    return this.invocarSeguros<string>('GET', `packs/colectiva/${codProductoVC}`);
  }

  tarificacionRapida(input: TarificacionRapidaIn): Observable<Recibo> {
    return this.invocarSeguros<Recibo>('POST', 'packs/tarificacion-rapida', input);
  }

  consultarCamposProyecto(idProyecto: number): Observable<CampoProductoVC[]> {
    return this.invocarSeguros<CampoProductoVC[]>('GET', `packs/campos/${idProyecto}`);
  }
}

